/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum EnteralNutritionStartAliases {
  ENTERAL_NUTRITION_START_ACCORDION = 'enteral-nutrition-start-accordion',
  ENTERAL_NUTRITION_START_ACCORDION_PANEL = 'enteral-nutrition-start-accordion-panel',
  ENTERAL_NUTRITION_START_ACCORDION_PLUS_TITLE_PANEL = 'enteral-nutrition-start-accordion-plus-title-panel',
  ENTERAL_NUTRITION_START_ACCORDION_PLUS_TITLE_TEXT = 'enteral-nutrition-start-accordion-plus-title-text',
  ENTERAL_NUTRITION_START_ACCORDION_TITLE_PANEL = 'enteral-nutrition-start-accordion-title-panel',
  ENTERAL_NUTRITION_START_ACCORDION_TITLE_TEXT = 'enteral-nutrition-start-accordion-title-text',
  ENTERAL_NUTRITION_START_BARCODE = 'enteral-nutrition-start-barcode',
  ENTERAL_NUTRITION_START_BARCODE_PANEL = 'enteral-nutrition-start-barcode-panel',
  ENTERAL_NUTRITION_START_BUTTON = 'enteral-nutrition-start-button',
  ENTERAL_NUTRITION_START_BUTTON_PANEL_PADDING = 'enteral-nutrition-start-button-panel-padding',
  ENTERAL_NUTRITION_START_CARD = 'enteral-nutrition-start-card',
  ENTERAL_NUTRITION_START_CARD_DECK = 'enteral-nutrition-start-card-deck',
  ENTERAL_NUTRITION_START_CARD_PANEL = 'enteral-nutrition-start-card-panel',
  ENTERAL_NUTRITION_START_CARDS_ACCORDION = 'enteral-nutrition-start-cards-accordion',
  ENTERAL_NUTRITION_START_CARDS_ACCORDION_PANEL = 'enteral-nutrition-start-cards-accordion-panel',
  ENTERAL_NUTRITION_START_CONTENT_PANEL = 'enteral-nutrition-start-content-panel',
  ENTERAL_NUTRITION_START_DATE_TIME_FIELD = 'enteral-nutrition-start-date-time-field',
  ENTERAL_NUTRITION_START_DATE_TIME_TEXT = 'enteral-nutrition-start-date-time-text',
  ENTERAL_NUTRITION_START_DEVICE_AUTOCOMPLETE = 'enteral-nutrition-start-device-autocomplete',
  ENTERAL_NUTRITION_START_DEVICE_FETCH = 'enteral-nutrition-start-device-fetch',
  ENTERAL_NUTRITION_START_DEVICE_FIELD = 'enteral-nutrition-start-device-field',
  ENTERAL_NUTRITION_START_DEVICE_MAPPER = 'enteral-nutrition-start-device-mapper',
  ENTERAL_NUTRITION_START_DEVICE_TEXT = 'enteral-nutrition-start-device-text',
  ENTERAL_NUTRITION_START_FORM = 'enteral-nutrition-start-form',
  ENTERAL_NUTRITION_START_INFUSION_FORM_AUTOCOMPLETE = 'enteral-nutrition-start-infusion-form-autocomplete',
  ENTERAL_NUTRITION_START_INFUSION_FORM_FETCH = 'enteral-nutrition-start-infusion-form-fetch',
  ENTERAL_NUTRITION_START_INFUSION_FORM_FIELD = 'enteral-nutrition-start-infusion-form-field',
  ENTERAL_NUTRITION_START_INFUSION_FORM_MAPPER = 'enteral-nutrition-start-infusion-form-mapper',
  ENTERAL_NUTRITION_START_INFUSION_FORM_TEXT = 'enteral-nutrition-start-infusion-form-text',
  ENTERAL_NUTRITION_START_INFUSION_SPEED_FIELD = 'enteral-nutrition-start-infusion-speed-field',
  ENTERAL_NUTRITION_START_INFUSION_SPEED_INPUT = 'enteral-nutrition-start-infusion-speed-input',
  ENTERAL_NUTRITION_START_JUSTIFICATION_FIELD = 'enteral-nutrition-start-justification-field',
  ENTERAL_NUTRITION_START_JUSTIFICATION_TEXT = 'enteral-nutrition-start-justification-text',
  ENTERAL_NUTRITION_START_LAYOUT = 'enteral-nutrition-start-layout',
  ENTERAL_NUTRITION_START_NAME_DATE_PANEL = 'enteral-nutrition-start-name-date-panel',
  ENTERAL_NUTRITION_START_NAME_FIELD = 'enteral-nutrition-start-name-field',
  ENTERAL_NUTRITION_START_NAME_TEXT = 'enteral-nutrition-start-name-text',
  ENTERAL_NUTRITION_START_NEW_DATE_FIELD = 'enteral-nutrition-start-new-date-field',
  ENTERAL_NUTRITION_START_NEW_DATE_INPUT = 'enteral-nutrition-start-new-date-input',
  ENTERAL_NUTRITION_START_OBSERVATION_TEXT = 'enteral-nutrition-start-observation-text',
  ENTERAL_NUTRITION_START_TEXT_OBSERVATION_FIELD = 'enteral-nutrition-start-text-observation-field',
  ENTERAL_NUTRITION_START_UNITY_AUTOCOMPLETE = 'enteral-nutrition-start-unity-autocomplete',
  ENTERAL_NUTRITION_START_UNITY_FETCH = 'enteral-nutrition-start-unity-fetch',
  ENTERAL_NUTRITION_START_UNITY_FIELD = 'enteral-nutrition-start-unity-field',
  ENTERAL_NUTRITION_START_UNITY_MAPPER = 'enteral-nutrition-start-unity-mapper',
  ENTERAL_NUTRITION_START_UNITY_TEXT = 'enteral-nutrition-start-unity-text',
  ENTERAL_NUTRITION_START_VOLUME_STEP_FIELD = 'enteral-nutrition-start-volume-step-field',
  ENTERAL_NUTRITION_START_VOLUME_STEP_INPUT = 'enteral-nutrition-start-volume-step-input',
  GLOBAL_ACTIONS = 'global-actions',
  LEGENDS_ENTERAL_NUTRITION_START = 'legends-enteral-nutrition-start',
}
export { EnteralNutritionStartAliases };
